import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userDetail: JSON.parse(localStorage.getItem('user')) || null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetail(state, actions) {
      state.userDetail = actions.payload;
    },
    clearUserDetail: (state) => {
      state.userDetail = null;
    }
  }
});

export default userSlice.reducer;

export const { setUserDetail, clearUserDetail } = userSlice.actions;
